const replaceString = /\\|\?|:|;|<|=|>|@|\[|\]|\^|_|`|\{|\}|\||~|（|）|〔|〕|［|］|｛|｝|〈|〉|《|》|「|」|『|』|【|】/g

export const state = {
  changeThumbnailPhotograph: '',
  loginUserPost: {
    userId: '',
    pronunciation: '',
    familyName: '',
    name: '',
    postId: '',
    postName: '',
    sub1PostName: '',
    sub2PostName: '',
    sub3PostName: '',
    sub4PostName: '',
    birthday: '',
    job: '',
    position: '',
    thumbnailPhotograph: '',
    passwordToken: '',
    foothold: '',
    phoneNumber: '',
    lastLoginDateTime: '',
    deviceId: ''
  },
  loginUsers: [],
  loginUserPostList: [],
  changeThumbnailPhotographList: [],
  footholdList: [],
  usersList: [],
  postSelect: '',
  searchvalue: '',
  lastUpdateDateTime: '',
  isChecked: false,
  total: 0,
  selectedLoginUsersList: []
}
export const mutations = {
  setLoginUsers(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
      state.total = 0
    }
    // ユーザ数の配列を作成する
    var arrayUserId = []
    var arrayfootholdId = []
    response.data['data'].forEach(function(data) {
      data['loginUserPost'].forEach(function(loginUserPost) {
        loginUserPost['loginUsers'].forEach(function(item) {
          if (item['foothold'] === true) {
            if (!arrayfootholdId.includes(item['userId'])) {
              arrayfootholdId.push(item['userId'])
            }
          } else {
            if (!arrayUserId.includes(item['userId'])) {
              arrayUserId.push(item['userId'])
            }
          }
        })
      })
    })
    state.footholdList = []
    state.usersList = []
    if (arrayUserId.length > 0 || arrayfootholdId.length > 0) {
      var dateNow = new Date()
      response.data['data'].forEach(function(data) {
        data['loginUserPost'].forEach(function(loginUserPost) {
          loginUserPost['loginUsers'].forEach(function(item) {
            var isNotSame = true
            state.footholdList.forEach(function(stateItem) {
              if (stateItem['userId'] === item['userId']) {
                isNotSame = false
              }
            })
            state.usersList.forEach(function(stateItem) {
              if (stateItem['userId'] === item['userId']) {
                isNotSame = false
              }
            })
            var lastLoginDateTime = new Date(item['lastLoginDateTime'])
            if (isNotSame) {
              if (item['foothold'] === true) {
                var foothold = []
                foothold = []
                if (
                  state.selectedLoginUsersList.some(
                    selectedLoginUser =>
                      selectedLoginUser.userId === item['userId']
                  )
                ) {
                  foothold['checked'] = true
                } else {
                  foothold['checked'] = false
                }
                foothold['postId'] = item['postId']
                foothold['postCode'] = item['postCode']
                foothold['postName'] = item['postName']
                foothold['sub1PostName'] = item['sub1PostName']
                foothold['sub2PostName'] = item['sub2PostName']
                foothold['sub3PostName'] = item['sub3PostName']
                foothold['sub4PostName'] = item['sub4PostName']
                foothold['userId'] = item['userId']
                foothold['familyName'] = item['familyName']
                foothold['name'] = item['name']
                foothold['pronunciation'] = item['pronunciation']
                foothold['job'] = item['job']
                foothold['position'] = item['position']
                foothold['thumbnailPhotograph'] = item['thumbnailPhotograph']
                foothold['phoneNumber'] = item['phoneNumber2']
                foothold['statusId'] = item['statusId']
                if (item['statusLimitDateTime'] != null) {
                  var statusLimitDateTime = new Date(
                    item['statusLimitDateTime']
                  )
                  if (dateNow.getTime() >= statusLimitDateTime.getTime()) {
                    foothold['statusId'] = 1
                  }
                }
                foothold['foothold'] = item['foothold']
                foothold['lastLoginDateTime'] = ''
                state.footholdList.push(foothold)
              } else {
                var user = []
                user = []
                if (
                  state.selectedLoginUsersList.some(
                    selectedLoginUser =>
                      selectedLoginUser.userId === item['userId']
                  )
                ) {
                  user['checked'] = true
                } else {
                  user['checked'] = false
                }
                user['postId'] = item['postId']
                user['postCode'] = item['postCode']
                user['postName'] = item['postName']
                user['sub1PostName'] = item['sub1PostName']
                user['sub2PostName'] = item['sub2PostName']
                user['sub3PostName'] = item['sub3PostName']
                user['sub4PostName'] = item['sub4PostName']
                user['userId'] = item['userId']
                user['familyName'] = item['familyName']
                user['name'] = item['name']
                user['pronunciation'] = item['pronunciation']
                user['job'] = item['job']
                user['position'] = item['position']
                user['thumbnailPhotograph'] = item['thumbnailPhotograph']
                user['phoneNumber'] = item['phoneNumber2']
                user['statusId'] = item['statusId']
                if (item['statusLimitDateTime'] != null) {
                  var statusLimitDateTime2 = new Date(
                    item['statusLimitDateTime']
                  )
                  if (dateNow.getTime() >= statusLimitDateTime2.getTime()) {
                    user['statusId'] = 1
                  }
                }
                user['foothold'] = item['foothold']
                user['lastLoginDateTime'] =
                  lastLoginDateTime.getFullYear() +
                  '/' +
                  (lastLoginDateTime.getMonth() + 1) +
                  '/' +
                  lastLoginDateTime.getDate() +
                  ' ' +
                  lastLoginDateTime.toLocaleTimeString()
                state.usersList.push(user)
                user['deviceId'] = item['deviceId']
              }
            }
          })
        })
      })
    } else {
      state.loginUsers = []
    }
    // 半角記号→半角数字の順になるように、文字コードで数字の後にある記号は置換してから比較する
    state.usersList.sort(function(a, b) {
      if (a.pronunciation !== b.pronunciation) {
        if (
          a.pronunciation.replace(replaceString, ' ') >
          b.pronunciation.replace(replaceString, ' ')
        )
          return 1
        if (
          a.pronunciation.replace(replaceString, ' ') <
          b.pronunciation.replace(replaceString, ' ')
        )
          return -1
      }
      if (a.familyName !== b.familyName) {
        if (
          a.familyName.replace(replaceString, ' ') >
          b.familyName.replace(replaceString, ' ')
        )
          return 1
        if (
          a.familyName.replace(replaceString, ' ') <
          b.familyName.replace(replaceString, ' ')
        )
          return -1
      }
    })
    state.footholdList.sort(function(a, b) {
      if (a.name !== b.name) {
        if (
          a.name.replace(replaceString, ' ') >
          b.name.replace(replaceString, ' ')
        )
          return 1
        if (
          a.name.replace(replaceString, ' ') <
          b.name.replace(replaceString, ' ')
        )
          return -1
      }
    })

    state.loginUsers = state.usersList.concat(state.footholdList)

    // 所属リスト用
    state.total = response.data['header']['total']
  },
  setUserPostList(state, response) {
    state.loginUserPostList = response.data['data']
  },
  setDetail(state, payload) {
    state.loginUserPost = ''
    // 一覧表示データから詳細画面表示用データを取得する
    var data = state.loginUsers.filter(function(row) {
      return row.userId === payload.userId
    })
    if (data.length !== 0) {
      state.loginUserPost = data[0]
    }
    if (state.loginUserPost !== '') {
      var dateNow = new Date()
      var itemStatusLimitDateTime = state.loginUserPost.statusLimitDateTime
      if (itemStatusLimitDateTime != null) {
        var statusLimitDateTime = new Date(itemStatusLimitDateTime)
        if (dateNow.getTime() >= statusLimitDateTime.getTime()) {
          state.loginUserPost.statusId = 1
        }
      }
    }
  },
  async fileDownload(state, response) {
    var reader = new FileReader()
    await reader.readAsDataURL(response.data)
    reader.onloadend = () => {
      state.changeThumbnailPhotograph = reader.result
    }
  },
  async fileDownloadList(state, response) {
    if (response == null) {
      var img = null
      var id = null
      state.changeThumbnailPhotographList.push({img, id})
    } else {
      var reader = new FileReader()
      await reader.readAsDataURL(response.data)
      reader.onloadend = () => {
        var img = reader.result
        var id = response.userId
        state.changeThumbnailPhotographList.push({img, id})
      }
    }
  },
  clearChangeThumbnailPhotographList(state) {
    state.changeThumbnailPhotographList = []
  },
  postSelect(state, payload) {
    state.postSelect = payload
  },
  searchvalue(state, payload) {
    state.searchvalue = payload
  },
  setLastUpdateDateTime(state, payload) {
    state.lastUpdateDateTime = payload
  },
  updateSelectedLoginUsersList(state, payload) {
    for (var i = 0; i < payload.length; i++) {
      if (
        payload[i].checked &&
        !state.selectedLoginUsersList.some(
          user => user.userId === payload[i].userId
        )
      ) {
        state.selectedLoginUsersList.push(payload[i])
      } else if (
        !payload[i].checked &&
        state.selectedLoginUsersList.some(
          user => user.userId === payload[i].userId
        )
      ) {
        const deleteIndex = state.selectedLoginUsersList.findIndex(
          user => user.userId === payload[i].userId
        )
        state.selectedLoginUsersList = state.selectedLoginUsersList.toSpliced(
          deleteIndex,
          1
        )
      }
    }
  },
  clearSelectedLoginUsersList(state) {
    state.selectedLoginUsersList = []
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/loginUserModules/loginUserMutation.js